import React from 'react';
import { storiesData } from '../data/mock';
import { Quote } from 'lucide-react';

export const Stories = () => {
  return (
    <section id="stories" className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Stories of Hope
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Every life has a story. Every story deserves to be heard.
          </p>
        </div>

        {/* Stories Grid */}
        <div className="grid md:grid-cols-2 gap-12">
          {storiesData.map((story, index) => (
            <div
              key={story.id}
              className={`flex flex-col ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              } gap-8 items-center bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 group`}
            >
              {/* Portrait Image */}
              <div className="flex-shrink-0 relative">
                <div className="w-48 h-48 rounded-full overflow-hidden ring-4 ring-amber-200 ring-offset-4 group-hover:ring-amber-400 transition-all duration-300">
                  <img
                    src={story.image}
                    alt={story.name}
                    className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
              </div>

              {/* Story Content */}
              <div className="flex-1">
                <div className="mb-4">
                  <h3 className="font-playfair text-3xl font-bold text-gray-900 mb-1">
                    {story.name}
                  </h3>
                  <p className="text-amber-600 font-medium">Age {story.age}</p>
                </div>
                <p className="text-gray-700 leading-relaxed mb-6">{story.story}</p>
                <div className="relative pl-6 border-l-4 border-amber-400">
                  <Quote className="absolute -left-3 -top-2 h-6 w-6 text-amber-400 fill-current" />
                  <p className="font-playfair text-lg italic text-gray-800">
                    {story.quote}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Closing Message */}
        <div className="mt-16 text-center">
          <p className="font-playfair text-2xl md:text-3xl text-amber-800 italic max-w-4xl mx-auto leading-relaxed">
            "These are just four stories among many. Each donation you make writes a new chapter of hope."
          </p>
        </div>
      </div>
    </section>
  );
};